/*
 * @Date: 2023-02-15 09:30:50
 * @Description: 文件描述
 */
import Vue from 'vue';
import api from './index';
import { axios } from '@/utils/request';
import ioa2 from '@/libs/MapAccount';
import { ACCESS_TOKEN } from '@/store/mutation-types';
/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return axios({
    url: '/auth/login',
    method: 'post',
    data: parameter,
  });
}

export function getSmsCaptcha(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter,
  });
}

export function getInfo() {
  return axios({
    url: '/user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function getInfoFromTks() {
  return ioa2.checkAuth().then((response) => {
    const userInfo = response.data;
    const roleList = userInfo?.role_code;
    Vue.ls.set(ACCESS_TOKEN, userInfo.token, 7 * 24 * 60 * 60 * 1000);
    return {
      result: {
        ...userInfo,
        name: userInfo.staffname,
        username: userInfo.staffname,
        roleList,
      },
    };
  });
}

export function logoutTks() {
  return ioa2.logout();
}

export function logout() {
  return axios({
    url: '/auth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return axios({
    url: api.twoStepCode,
    method: 'post',
    data: parameter,
  });
}
